export default function emailValidator(email, allowEmpty = false) {
  if (allowEmpty && !email) return true

  const emailLowercase = email.toLowerCase()
  const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/

  return emailRegex.test(emailLowercase)
}
